import _ from 'underscore';
import { t } from 'services/translation';
import { lowercase } from 'lib/string_utils';

const DEFAULT_DATE_FORMAT = 'DD-MM-YYYY';

var Helper = {
  defaults: {
    fromDate: {
      name: 'from',
      dateFormat: 'MMM DD',
      disabled: false,
      placeholder: lowercase(`${t('FROM')}`),
      className: 'field',
      value: null,
    },
    toDate: {
      name: 'to',
      dateFormat: `${t('TO')} MMM DD`,
      disabled: true,
      placeholder: t('TO'),
      className: 'field',
      value: null,
    },
    defaultDateFormat: DEFAULT_DATE_FORMAT,
    className: '',
    onChange() {},
    label: null,
  },

  props(overrides) {
    return {
      fromDate: _.extend({}, Helper.defaults.fromDate, overrides.fromDate),
      toDate: _.extend({}, Helper.defaults.toDate, overrides.toDate),
      defaultDateFormat:
        overrides.defaultDateFormat || Helper.defaults.defaultDateFormat,
      onChange: overrides.onChange || Helper.defaults.onChange,
      className: overrides.className || Helper.defaults.className,
      label: overrides.label || Helper.defaults.label,
    };
  },
};

export default Helper;
